import { Box, Button, Flex, Text, Title } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import DocumentItemForm from "./DocumentItemForm";

interface DocumentsTabContentProps {
  isViewMode?: boolean;
  additionalDocs: any[];
  existingDocs: any[];
  onAddAdditionalDoc: () => void;
  onUpdateAdditionalDoc: (index: number, field: string, value: any) => void;
  onRemoveAdditionalDoc: (index: number) => void;
  onDeleteExistingDoc: (docId: string) => void;
}

const DocumentsTabContent = ({
  isViewMode = false,
  additionalDocs,
  existingDocs,
  onAddAdditionalDoc,
  onUpdateAdditionalDoc,
  onRemoveAdditionalDoc,
  onDeleteExistingDoc,
}: DocumentsTabContentProps) => {
  return (
    <Box pos="relative">
      <Box mb="xl">
        <Flex justify="space-between" align="flex-start" mb="md">
          <Box>
            <Title order={4} mb={4} fw={400}>
              Additional Documents
            </Title>
            <Text fz="sm" c="slate.6">
              Upload any other relevant documents.
            </Text>
          </Box>
          {!isViewMode && (
            <Button leftSection={<IconPlus size={20} />} onClick={onAddAdditionalDoc} variant="filled" color="primary">
              Add Documents
            </Button>
          )}
        </Flex>

        {existingDocs.map((doc: any) => (
          <DocumentItemForm
            key={doc.id}
            type="additional"
            existingDoc={doc}
            isViewMode={isViewMode}
            onDelete={() => onDeleteExistingDoc(doc.id)}
          />
        ))}

        {additionalDocs.map((doc, index) => (
          <DocumentItemForm
            key={`new-${doc.clientId || index}`}
            type="additional"
            index={index}
            data={doc}
            onChange={(field, value) => onUpdateAdditionalDoc(index, field, value)}
            onRemove={() => onRemoveAdditionalDoc(index)}
            isViewMode={isViewMode}
          />
        ))}
      </Box>
    </Box>
  );
};

export default DocumentsTabContent;
